module.exports = '<svg width="36" height="32" viewBox="0 0 36 32"><path d="M4 30.4c0 1.1.9 1.6 2 1.6h24c1.1 0 2-.5 2-1.6L36 13a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1l4 17.4zM14.2 0H6C4.9 0 4 1.1 4 2.2V7a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V6a2 2 0 0 0-2-2H16V2.2c0-1.1-.7-2.2-1.8-2.2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/open-folder-3.js
// module id = 1321
// module chunks = 14